import { EnhancedPayrollReport } from '../../interfaces/report.interface';
import { EPT_REPORTS } from './ept-by-jurisdiction';
import { PierReview } from './pier-review';
import { RL1Preview } from './rl1-preview';
import { RqRemittance } from './rq-remittance';
import { T4Preview } from './t4-preview';
import { WorkersCompensationReporting } from './workers-compensation';

const ENHANCED_REPORTS = [
    PierReview,
    T4Preview,
    RL1Preview,
    RqRemittance,
    WorkersCompensationReporting,
] as const satisfies readonly EnhancedPayrollReport[];

// Maps all enhanced reports by their routerLink. This allows us to easily identify which report type is being requested via the URL segment
const ENHANCED_REPORTS_MAP = [...ENHANCED_REPORTS, ...EPT_REPORTS].reduce(
    (acc, cur) => ({ ...acc, [typeof cur.routerLink === 'string' ? cur.routerLink : cur.routerLink.join('/')]: cur }),
    {} as Record<string, EnhancedPayrollReport>
);

export {
    ENHANCED_REPORTS,
    ENHANCED_REPORTS_MAP,
    EPT_REPORTS,
    PierReview,
    RL1Preview,
    RqRemittance,
    T4Preview,
    WorkersCompensationReporting,
};
